import type { SendEventHandler } from "../typings";

const POST_METHOD = "POST";
const READYSTATE_COMPLETE = 4;
const supportsBeacon = window.navigator && "sendBeacon" in window.navigator;

const beaconSendEventHandler: SendEventHandler = (url, data) => {
  navigator.sendBeacon(url, data);
};

const xhrSendEventHandler: SendEventHandler = (url, data, onSuccess) => {
  const req = new XMLHttpRequest();

  req.open(POST_METHOD, url, true);
  req.setRequestHeader("Content-Type", "application/json");

  req.onreadystatechange = function () {
    if (req.readyState === READYSTATE_COMPLETE) {
      onSuccess({ statusCode: req.status });
    }
  };
  req.send(data);
};

const createDefaultHandler = () =>
  supportsBeacon ? beaconSendEventHandler : xhrSendEventHandler;

export const defaultSendEventHandler: SendEventHandler = createDefaultHandler();
